import React, { useState, useRef, useEffect } from 'react';
import { Card, Form, Button, Row, Col, Spinner } from 'react-bootstrap';
import { chatAPI } from '../api';
import WelcomeMessage from '../components/WelcomeMessage';

const ChatbotPage = () => {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const messagesEndRef = useRef(null);

  // 메시지 변경 시 자동 스크롤
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const handleSend = async (text = input) => {
    if (!text.trim()) return;

    const userMessage = { role: 'user', content: text };
    setMessages(prev => [...prev, userMessage]);
    setInput('');
    setLoading(true);

    try {
      const response = await chatAPI.sendMessage(text);
      
      const botMessage = { 
        role: 'assistant', 
        content: response.data.response,
        downloadUrl: response.data.download_url // ✅ download_url 추가
      };
      
      console.log('=== API 응답 ===');
      console.log('response:', response.data.response);
      console.log('download_url:', response.data.download_url);
      
      setMessages(prev => [...prev, botMessage]);
    } catch (error) {
      console.error('Chat error:', error);
      const errorMessage = {
        role: 'assistant',
        content: 'API 연결에 실패했습니다. Backend 서버를 확인해주세요.'
      };
      setMessages(prev => [...prev, errorMessage]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="chatbot-page">
      <Card>
        <Card.Body>
          <div className="messages-area">
            {messages.length === 0 ? (
              <WelcomeMessage onQuestionClick={(q) => handleSend(q)} />
            ) : (
              messages.map((msg, idx) => {
                return (
                  <div key={idx} className={`message ${msg.role === 'user' ? 'user-message' : 'bot-message'}`}>
                    <div className="message-content">
                      <div style={{ whiteSpace: 'pre-line' }}>
                        {msg.content}
                      </div>
                      
                      {/* download_url이 있으면 다운로드 버튼 표시 */}
                      {msg.downloadUrl && (
                        <div className="mt-3">
                          <Button
                            variant="success"
                            size="sm"
                            onClick={() => window.open(msg.downloadUrl, '_blank')}
                            style={{ 
                              width: '100%', 
                              maxWidth: '200px',
                              fontSize: '14px',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis'
                            }}
                          >
                            <i className="fas fa-download me-2"></i>
                            PDF 다운로드
                          </Button>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })
            )}
            
            {loading && (
              <div className="text-center mt-3">
                <Spinner animation="border" size="sm" />
              </div>
            )}
            
            {/* 자동 스크롤 타겟 */}
            <div ref={messagesEndRef} />
          </div>

          <Form.Group className="mt-3">
            <Row>
              <Col>
                <Form.Control
                  type="text"
                  placeholder="질문을 입력하세요..."
                  value={input}
                  onChange={(e) => setInput(e.target.value)}
                  onKeyPress={(e) => e.key === 'Enter' && handleSend()}
                  disabled={loading}
                />
              </Col>
              <Col xs="auto">
                <Button 
                  variant="primary" 
                  onClick={() => handleSend()}
                  disabled={loading}
                >
                  전송
                </Button>
              </Col>
            </Row>
          </Form.Group>
        </Card.Body>
      </Card>
    </div>
  );
};

export default ChatbotPage;
